module.exports = __webpack_public_path__ + "img/platinumcinemas.b9c18b48.png";